import {
    REQUEST_SHIPMENT,
    REQUEST_SHIPMENT_FAILURE,
    REQUEST_SHIPMENT_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";

const initialState = {
    shipment: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const shipmentReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SHIPMENT:
            return {
                ...state,
                shipment: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SHIPMENT_SUCCESS:
            return {
                ...state,
                shipment: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SHIPMENT_FAILURE:
            return {
                ...state,
                shipment: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
